import React from "react";
import "./common_cards.css";

// pass that data as props { cards }

const CommonCards = ({ cards }) => {
  return (
    <div className="common-cards-container">
      {cards?.map((card, index) => (
        <div className="common-cards" key={index}>
          <img src={card.logo} alt={card.title} />
          <h1 className="common-cards-title">{card.title}</h1>
          <h2 className="subtitle">{card.subtitle}</h2>
        </div>
      ))}
    </div>
  );
};

export default CommonCards;
